import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfigService, GenerateIbanService } from 'common';

@Component({
  selector: 'gsp-iban-generator',
  templateUrl: './iban-generator.component.html',
  styleUrls: ['./iban-generator.component.css']
})
export class IbanGeneratorComponent implements OnInit {
  @Output() iban = new EventEmitter<string>();
  @Input() country: string;
  isLowerEnvironment: boolean = true;

  constructor(private configService: ConfigService, private ibanService: GenerateIbanService) { }

  ngOnInit(): void {
    this.isLowerEnvironment = JSON.parse(this.configService.resourceEditMode.toLowerCase());
  }

  generate() {
    this.iban.emit(this.ibanService.generateIban(this.country));
  }

}
